'use client'

import { useEffect, useRef } from 'react'
import { useSegmentAnalytics, useSegmentTrackMeta } from './Provider'

export const PageViewed = ({ children, pageName }: { children: React.ReactNode; pageName: string }) => {
  const analytics = useSegmentAnalytics()
  const { setPageName } = useSegmentTrackMeta()
  const emitted = useRef(false)

  // Ref write during render so descendant effects (Form Action / impressions) see pageName.
  setPageName(pageName)

  useEffect(() => {
    if (emitted.current) return

    emitted.current = true

    // PEDD: emit page views via analytics.page() only — do not fire a separate Page Viewed track.
    // https://nerdwallet.atlassian.net/wiki/spaces/PEDD/pages/4782751755/Standard+Segment+Event+Taxonomy#Page-Events-(Page-Viewed)
    analytics.page(pageName, {
      name: pageName,
      flow_name: pageName,
    })
  }, [analytics, pageName])

  return <>{children}</>
}
